import React, { useState, useEffect, useRef } from 'react';
import { EntityService } from "../service/EntityService";
import { LanguageService } from "../service/LanguageService";
import classNames from 'classnames';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Toast } from 'primereact/toast';
import { Button } from 'primereact/button';
import { Toolbar } from 'primereact/toolbar';
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import { ProgressSpinner } from 'primereact/progressspinner';
import { AuthorizationService } from '../service/AuthorizationService';
import './Crud.scss'
import * as _ from 'lodash';
import { ProgressBar } from 'primereact/progressbar';
import { v4 as uuidv4 } from 'uuid';
import {Chips} from 'primereact/chips';
import { Paginator } from 'primereact/paginator';
import { Fieldset } from 'primereact/fieldset';
import { ToggleButton } from 'primereact/togglebutton';
import { InputTextarea } from 'primereact/inputtextarea';
import { Dropdown } from 'primereact/dropdown';

export function EntityCrud(props) {

    let emptyEntityInstance  = {
        id: uuidv4()
    };

    const VIEW_MODE = "VIEW";
    const EDIT_MODE = "EDIT";

    const [entityInstances, setEntityInstances] = useState([]);
    
    const [entityInstanceDialog, setEntityInstanceDialog] = useState(false);
    const [entityInstanceDialogMode, setEntityInstanceDialogMode] = useState(VIEW_MODE);

    const [deleteEntityInstanceDialog, setDeleteEntityInstanceDialog] = useState(false);
    const [entityInstance, setEntityInstance] = useState(emptyEntityInstance);
    const [submitted, setSubmitted] = useState(false);
    const [globalFilter, setGlobalFilter] = useState(null);
    const [hasAccess, setHasAccess] = useState(false);
    const [saving, setSaving] = useState(false);
    const [loading, setLoading] = useState(true);
    const toast = useRef(null);
    const dt = useRef(null);
    const entityService = new EntityService(props.entity, props.module);
    const authorizationService = new AuthorizationService(props.module);
    const languageService = new LanguageService(props.module);
    
    const [search, setSearch] = useState('');
    const [sortField, setSortField] = useState('');
    const [sortOrder, setSortOrder] = useState(1);
    const [totalRecords, setTotalRecords] = useState(0);
    const [first, setFirst] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(25);


    /* Crud configuration */
    const config = props.config || {};
    const isOperationAllowed = (opId) => {
        return config.allowedOperations ? config.allowedOperations.indexOf(opId) >= 0 : true;
    }
    const isOneOfOperationsAllowed = (opIds) => {
        for(let i = 0; i < opIds.length; i++){
            if(isOperationAllowed(opIds[i])){
                return true;
            }
        }
        return false;
    }
    /* ------------------ */

    const updateList = async () => {
        const data = await entityService.list(first, rowsPerPage, search, sortField, sortOrder);
        setEntityInstances(data.items);
        setTotalRecords(data.totalRecords)
    }

    const onPageChange = async (pageEvent) => {
        setFirst(pageEvent.first);
        setRowsPerPage(pageEvent.rows);
        const data = await entityService.list(pageEvent.first, pageEvent.rows, search, sortField, sortOrder);
        setEntityInstances(data.items);
        setTotalRecords(data.totalRecords)
    }

    const doSearch = async (reset) => {
        const data = await entityService.list(first, rowsPerPage, reset ? null : globalFilter, sortField, sortOrder);
        setSearch(globalFilter);
        setEntityInstances(data.items);
        setTotalRecords(data.totalRecords)
    }

    const onSort = async (sortEvent) => {
        setSortField(sortEvent.sortField);
        setSortOrder(sortEvent.sortOrder);
        const data = await entityService.list(first, rowsPerPage, search, sortEvent.sortField, sortEvent.sortOrder);
        setEntityInstances(data.items);
        setTotalRecords(data.totalRecords)
    }

    useEffect(() => {
        try {
            const _hasAccess = authorizationService.hasPermission(props.permission);
            setHasAccess(_hasAccess);
            if(_hasAccess){
                async function fetchData() {
                    await updateList();
                    setLoading(false); 
                }        
                fetchData();
                
            }
        } catch (error) {
            toast.current.show({ severity: 'error', summary: 'Error', detail: error.toString(), sticky: true });
        }
        
    }, []);

    const openNew = () => {
        //emptyClient.id = uuidv4();
        setEntityInstance(entityService.getEmptyInstance());
        setSubmitted(false);
        setEntityInstanceDialog(true);
    }

    const hideDialog = () => {
        if(!saving){
            setSubmitted(false);
            setEntityInstanceDialog(false);
        }
    }

    const hideDeleteClientDialog = () => {
        setDeleteEntityInstanceDialog(false);
    }

    const saveDisabled = () => {
        return (entityInstance.name || "") === ""
            || (entityInstance.shortcode || "") === ""
            || (entityInstance.logo || "") === ""
            || (entityInstance.powerbi_username || "") === ""
            || (entityInstance.powerbi_password || "") === ""
            || (entityInstance.powerbi_appid || "") === ""
            || (entityInstance.powerbi_secret || "") === "";
    }

    const saveClient = async () => {
        try {
            setSaving(true);
            setSubmitted(true);

            if (entityInstance.name.trim()) {
                if (entityInstance.id) {
                    await entityService.update(entityInstance);
                    toast.current.show({ severity: 'success', summary: languageService.getText('Successful'), detail: languageService.getText('Client_Updated'), life: 3000 });
                }
                else {
                    await entityService.create(entityInstance);
                    toast.current.show({ severity: 'success', summary: languageService.getText('Successful'), detail: languageService.getText('Client_Created'), life: 3000 });
                }

                await updateList();
                setEntityInstanceDialog(false);
                setEntityInstance(entityService.getEmptyInstance());
                setSaving(false);
            }
        } catch (error) {
            toast.current.show({ severity: 'error', summary: 'Error', detail: error.toString(), sticky: true });
            setSaving(false);
            console.log(error);
            throw error;
        }
    }

    const viewEntityInstance = (entityInstance) => {
        setEntityInstance({ ...entityInstance });
        setEntityInstanceDialogMode(VIEW_MODE);
        setEntityInstanceDialog(true);
    }

    const editEntityInstance = (entityInstance) => {
        setEntityInstance({ ...entityInstance });
        setEntityInstanceDialog(true);
    }

    const confirmDeleteEntityInstance = (entityInstance) => {
        setEntityInstance(entityInstance);
        setDeleteEntityInstanceDialog(true);
    }

    const deleteClient = async () => {
        try {
            setSaving(true);
            await entityService.delete(entityInstance);
            setEntityInstances(await entityService.list());
            setDeleteEntityInstanceDialog(false);
            setEntityInstance(entityService.getEmptyInstance());
            setSaving(false);
            toast.current.show({ severity: 'success', summary: languageService.getText('Successful'), detail: languageService.getText('Client_Deleted'), life: 3000 });    
        } catch (error) {
            console.log(error);
            throw error;
        }
    }

    const onInputChange = (e, name) => {
        const val = (e.target && e.target.value) || '';
        let _client = { ...entityInstance };
        _.set(_client, name, val);
        setEntityInstance(_client);
    }

    const onValueChange = (val, name) => {
        console.log(val, name)
        let _client = { ...entityInstance };
        _.set(_client, name, val);
        setEntityInstance(_client);
    }

    const leftToolbarTemplate = () => {
        return (
            <React.Fragment>
                { isOperationAllowed("ADD") && <Button label={languageService.getText("New")} icon="pi pi-plus" className="p-button-success p-mr-2" onClick={openNew} />}
            </React.Fragment>
        )
    }

    const actionBodyTemplate = (rowData) => {
        return (
            <React.Fragment>
                { isOperationAllowed("VIEW") && <Button icon="pi pi-eye" className="p-button-rounded p-button-success p-mr-2" onClick={() => viewEntityInstance(rowData)} /> }
                { isOperationAllowed("EDIT") && <Button icon="pi pi-pencil" className="p-button-rounded p-button-success p-mr-2" onClick={() => editEntityInstance(rowData)} /> }
                { isOperationAllowed("DELETE") && <Button icon="pi pi-trash" className="p-button-rounded p-button-warning" onClick={() => confirmDeleteEntityInstance(rowData)} /> }
                
            </React.Fragment>
        );
    }

    const header = (
        <div className="table-header">
            <h5 className="p-m-0">{languageService.getText(config.title)}</h5>
            { isOperationAllowed("SEARCH") &&
                <span className="p-input-icon-left">
                    <i className="pi pi-search" />
                    <InputText type="search" onInput={(e) => {setGlobalFilter(e.target.value); if(e.target.value === "") doSearch(true);}} placeholder="Search..."  onKeyDown={(e) => { if (e.key === 'Enter') { doSearch()}}}/>
                </span>
            }
            {
                (config.globalOperations || []).filter(operation => operation.condition()).map(operation => <>
                    <Button disabled={props.processing} label={operation.label} icon={`pi ${operation.icon}`} className="p-button-rounded p-button-warning" onClick={async () => {
                            try {
                                await operation.operation();    
                                console.log("Atualizando a lista");
                                await updateList();
                                if(operation.successMessage){
                                    toast.current.show({ severity: 'success', summary: "Sucesso", detail: operation.successMessage, life: 3000 });    
                                }
                            } catch (error) {
                                toast.current.show({ severity: 'error', summary: 'Error', detail: error.toString(), sticky: true });
                            }
                            
                        }
                    } />
                </>)
            }
        </div>
    );

    const clientDialogFooter = (
        <React.Fragment>
            { !saving && <Button label={languageService.getText("Cancel")} icon="pi pi-times" className="p-button-text" onClick={hideDialog} />}
            { !saving && <Button disabled={saveDisabled()} label={languageService.getText("Save")} icon="pi pi-check" className="p-button-text" onClick={saveClient} />}
            { saving && <ProgressSpinner style={{width: '20px', height: '20px'}} strokeWidth="8"/>}
        </React.Fragment>
    );
    const deleteClientDialogFooter = (
        <React.Fragment>
            { !saving && <Button label={languageService.getText("No")} icon="pi pi-times" className="p-button-text" onClick={hideDeleteClientDialog} />}
            { !saving && <Button label={languageService.getText("Yes")} icon="pi pi-check" className="p-button-text" onClick={deleteClient} />}
            { saving && <ProgressSpinner style={{width: '20px', height: '20px'}} strokeWidth="8"/>}
        </React.Fragment>
    );

    const addTag = () => {
        if(!entityInstance.tags){
            entityInstance.tags = [];
        }

        entityInstance.tags.push({
            id: uuidv4(),
            name: '',
            client_id: entityInstance.id,
            values: []
        });

        setEntityInstance(entityInstance);
    }

    const removeTag = (tag_id) => {
        entityInstance.tags.find(t => t.id === tag_id).deleted = true;
        setEntityInstance(Object.assign({}, entityInstance));
    }

    const onChangeTagName = (e, id) => {
        entityInstance.tags.find(t => t.id === id).name = e.target.value;
        setEntityInstance(Object.assign({}, entityInstance));
    }

    const addTagValue = (tag_id, name) => {
        entityInstance.tags.find(t => t.id === tag_id).values.push({ id: uuidv4(), name, tag_id });
        setEntityInstance(Object.assign({}, entityInstance));
    }

    const removeTagValue = (tag_id, value) => {
        entityInstance.tags.find(t => t.id === tag_id).values.find(v => v.id === value[0].id).deleted = true;
        setEntityInstance(Object.assign({}, entityInstance));
    }

    if(hasAccess){
        return (
            <div className="datatable-crud-demo">
                <Toast ref={toast} />
                <div className="card">
                    { (loading || props.processing)  && <ProgressBar mode="indeterminate"/> }
                    { !loading && isOperationAllowed("ADD") && <Toolbar className="p-mb-4" left={leftToolbarTemplate}></Toolbar>}

                    { !loading &&
                    <>
                    <DataTable ref={dt} value={entityInstances}
                        dataKey="id"
                        header={header}
                        autoLayout={true}
                        onSort={onSort}
                        sortField={sortField} 
                        sortOrder={sortOrder}
                        >

                        { config.listAttributes.map((attribute, i) => 
                            <Column key={`attribute_${i}`} header={languageService.getText(attribute.label)} body={(data) => attribute.transform ? attribute.transform(_.get(data, attribute.value)) : _.get(data, attribute.value)}></Column>
                        )}
                        
                        { isOneOfOperationsAllowed(["VIEW","EDIT","DELETE"]) && <Column style={{width: '150px'}} body={actionBodyTemplate}></Column>}
                    </DataTable>

                    <Paginator first={first} rows={rowsPerPage} totalRecords={totalRecords} rowsPerPageOptions={[5, 10, 25, 50, 100]} onPageChange={onPageChange}></Paginator>
                    </>
                    }
                </div>

                { entityInstance && entityInstanceDialogMode === VIEW_MODE && <>
                <Dialog 
                    visible={entityInstanceDialog} 
                    style={{ width: '80vw' }} 
                    header={config.view.title} 
                    modal 
                    className="p-fluid" 
                    footer={
                        <>
                            { props.processing && <ProgressSpinner style={{width: '20px', height: '20px'}} strokeWidth="8"/> }
                            { !props.processing && <>
                                { config.view.operations.filter(operation => operation.condition(entityInstance)).map(operation => 
                                    <Button label={languageService.getText(operation.label)} icon={`pi ${operation.icon}`} className="p-button-text" 
                                        onClick={async () => {
                                            await operation.operation(entityInstance);
                                            await updateList();
                                            setEntityInstanceDialog(false);
                                        } 
                                    }/>
                                )}
                            </>}    
                        </>
                    } 
                    onHide={hideDialog}>
                        { (config.view.groups || []).map(group => 
                            <Fieldset style={{marginTop: '10px'}} key={group.key} legend={languageService.getText(group.label)}>
                                <div className="p-grid">
                                { 
                                    config.view.attributes.filter(attribute => attribute.group === group.key).map((attribute, i) => 
                                        <div key={`att_${i}`} className={`p-col-${attribute.columns || 6} p-grid`}>
                                            <div className="p-col-12"><b>{languageService.getText(attribute.label)}</b></div>
                                            { 
                                                Array.isArray(_.get(entityInstance, attribute.value)) ? 
                                                    <DataTable ref={dt} value={_.get(entityInstance, attribute.value)}
                                                        dataKey="id"
                                                        autoLayout={true}
                                                        >

                                                        { attribute.listColumns.map((column, i) => 
                                                            <Column 
                                                                key={`attribute_${i}`} 
                                                                header={column.id ? column.label : column } 
                                                                body={(data) => column.transform ? column.transform(_.get(data, column.id ? column.id : column)) : _.get(data, column.id ? column.id : column)}></Column>
                                                        )}
                                                    </DataTable>
                                                :
                                                    <div className="p-col-12">{ attribute.transform ? attribute.transform(_.get(entityInstance, attribute.value)) : _.get(entityInstance, attribute.value)}</div>
                                            }
                                        </div>    
                                    )
                                }
                                </div>  
                            </Fieldset>    
                        )}
                        { (config.view.groups || []).length === 0 && 
                            <>
                            <div className="p-grid">
                            { 
                                config.view.attributes.map((attribute, i) => 
                                    <div key={`att_${i}`} className={`p-col-${attribute.columns || 6} p-grid`}>
                                        <div className="p-col-12"><b>{languageService.getText(attribute.label)}</b></div>
                                        <div className="p-col-12">{ attribute.transform ? attribute.transform(_.get(entityInstance, attribute.value)) : _.get(entityInstance, attribute.value)}</div>
                                    </div>    
                                )
                            }
                            </div>    
                            </>
                        }
                    

                </Dialog></>}

                { entityInstance && entityInstanceDialogMode === EDIT_MODE && <>
                <Dialog visible={entityInstanceDialog} style={{ width: '90vw' }} header="Client Details" modal className="p-fluid" footer={clientDialogFooter} onHide={hideDialog}>
                    {entityInstance.image && <img src={`assets/demo/images/entityInstance/${entityInstance.image}`} onError={(e) => e.target.src = 'https://www.primefaces.org/wp-content/uploads/2020/05/placeholder.png'} alt={entityInstance.image} className="entityInstance-image" />}
                    <div className="p-field">
                        <label htmlFor="name">{languageService.getText("Name")}*</label>
                        <InputText disabled={saving} id="name" value={entityInstance.name} onChange={(e) => onInputChange(e, 'name')} required autoFocus className={classNames({ 'p-invalid': submitted && !entityInstance.name })} />
                        {submitted && !entityInstance.name && <small className="p-invalid">{languageService.getText("Name")} {languageService.getText("is_required")}.</small>}
                    </div>

                </Dialog></>}

                <Dialog visible={deleteEntityInstanceDialog} style={{ width: '450px' }} header="Confirm" modal footer={deleteClientDialogFooter} onHide={hideDeleteClientDialog}>
                    <div className="confirmation-content">
                        <i className="pi pi-exclamation-triangle p-mr-3" style={{ fontSize: '2rem' }} />
                        {entityInstance && <span>Are you sure you want to delete <b>{entityInstance.name}</b>?</span>}
                    </div>
                </Dialog>
            </div>
        );
    }
    else {
        return (
            <div className="datatable-crud-demo">
                <div className="card">
                    <b>Permission Denied</b>
                </div>
            </div>
        );
    }
}